export class PlanPriceModel {
  constructor(
    public _id: string,
    public deleted: boolean,
    public price: number,
    public title: string,
    public sku: string,
    public duration: number,
    public createdAt: string,
    public updatedAt: string,
    public __v: number,
    public totalPrice: number,
    public rawMonthlyPrice: number,
    public profitAmount: number,
    public discountPercent: number,
    public discountedMonthlyPrice: number,
    public promotion?: ShopPromotionModel
  ) {}
}

export class ShopPromotionModel {
  constructor(
    public title: string,
    public startDate: number,
    public endDate: number,
    public _id: string,
    public percent: number,
    public expireStatus: string,
    public totalPriceString: string,
    public monthlyPriceString: string
  ) {}
}

export class PlanSubscriptionModel {
  constructor(public remainingDays: number, public expireDate: number) {}
}

export class SavedSubscriptionModel {
  constructor(public updatedAt: string, public expireDate: number) {}

  static fromJSON(json: SubscriptionJSON | string): SavedSubscriptionModel {
    if (typeof json === 'string') {
      // if it's a string, parse it first
      return JSON.parse(json, SavedSubscriptionModel.reviver);
    } else {
      // create an instance of the User class
      const subs = Object.create(SavedSubscriptionModel.prototype);
      // copy all the fields from the json object
      return Object.assign(subs, json, {
        // convert fields that need converting
      });
    }
  }

  static reviver(key: string, value: any): any {
    return key === '' ? SavedSubscriptionModel.fromJSON(value) : value;
  }
}

interface SubscriptionJSON {
  updatedAt: string;
  expireDate: number;
}

export class ShopDataLogModel {
  constructor(
    public sku: string,
    public amount: number,
    public title?: string
  ) {}

  static fromJSON(json: ShopDataLogJSON | string): ShopDataLogModel {
    if (typeof json === 'string') {
      // if it's a string, parse it first
      return JSON.parse(json, ShopDataLogModel.reviver);
    } else {
      // create an instance of the User class
      const dataLog = Object.create(ShopDataLogModel.prototype);
      // copy all the fields from the json object
      return Object.assign(dataLog, json, {
        // convert fields that need converting
      });
    }
  }

  static reviver(key: string, value: any): any {
    return key === '' ? ShopDataLogModel.fromJSON(value) : value;
  }
}

interface ShopDataLogJSON {
  sku: string;
  amount: number;
}
// public discountplans: PlanPriceModel[],
// public discountCode: string
export class AutomaticDiscountPriceResponseModel {
  constructor(public plans: PlanPriceModel[]) {}
}
